import * as types from '../actions/actionTypes';

const initialState = {
  showAssignQuotePopup: false,
  assignQuotePopupSearchText: "",
  assignQuotePopupEmployee: null,
  assignQuotePopupCustomer: null,
  assignQuotePopupSuccessText: "",
  assignQuoteCloneMode: false,
  assignQuoteOfflineCustomers: [],
  assignQuoteOfflineEmployees: [],
  assignQuotePopupSaveButtons: "all", // save or checkout or updateTax
};

export default function(state = initialState, action) {

  switch(action.type) {

    case types.TOGGLE_SHOW_ASSIGN_QUOTE_POPUP:
    case types.SET_ASSIGN_QUOTE_POPUP_SEARCH_TEXT:
    case types.SET_ASSIGN_QUOTE_POPUP_EMPLOYEE:
    case types.SET_ASSIGN_QUOTE_POPUP_CUSTOMER:
    case types.SET_ASSIGN_QUOTE_POPUP_SUCCESS_TEXT:
    case types.SET_ASSIGN_QUOTE_CLONE_MODE:
    case types.SET_ASSIGN_QUOTE_OFFLINE_DATA:
      return Object.assign({}, state, {
        ...action.payload
      });
  }

  return state;

}
